import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { School } from '../schools';

@Component({
    selector: 'app-view-school-dialog',
    templateUrl: './view-school-dialog.component.html',
    styleUrls: ['./view-school-dialog.component.scss'],
})
export class ViewSchoolDialogComponent implements OnInit {
    title = 'Schools Editor';
    school: School;

    constructor(private dialogRef: MatDialogRef<ViewSchoolDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.school = data.school;
    }

    ngOnInit(): void {
        this.title = this.data.title;
    }

    onSubmit(): void {
        this.dialogRef.close(null);
    }
}
